import { createContext } from 'react'

const AppLoadedContext = createContext({})

export default AppLoadedContext
